// ─── LOGOS ────────────────────────────────────────────────────────────────
import logoPrimary from '@media/logos/AH_Logo_White.webp'
// 454x72 (2x of the 36 px header/footer render). The full 1920x304 master is
// 49 KB and was flagged by Lighthouse; this one is ~9 KB.
import logoPrimaryNav from '@media/logos/AH_Logo_White-nav.webp'
import logoMonogramWhiteV1 from '@media/logos/logo-ah-monogram-white-v1.webp'
import logoMonogramWhiteV2 from '@media/logos/logo-ah-monogram-white-v2.webp'
import logoMonogramBlackCropped from '@media/logos/logo-ah-monogram-black-cropped.webp'
import logoMonogramBlackSolid from '@media/logos/logo-ah-monogram-black-nontransparent.webp'
import logoWordmarkBlack from '@media/logos/logo-ah-wordmark-black-horizontal.webp'
import logoCommunityBlack from '@media/logos/logo-ah-community-black.webp'
import logoConfidentRidersBlack from '@media/logos/logo-ah-confidentriders-black.webp'
import logoRidersWayNavy from '@media/logos/logo-ridersway-navy-tagline.webp'
import logoRidersWayWordmark from '@media/logos/logo-ridersway-wordmark-leather.webp'
import logoRidersWayIcon from '@media/logos/logo-ridersway-icon.webp'
import logoHorseTvRed from '@media/logos/logo-horsetv-red.webp'

// ─── SCOTT ────────────────────────────────────────────────────────────────
import scottHeadshotArena from '@media/scott/scott-headshot-arena-goldenhour.webp'
import scottBackviewCowboyHat from '@media/scott/scott-backview-cowboyhat-sky.webp'
import scottBondingHorseBw from '@media/scott/scott-bonding-horse-bw-smile.webp'
import scottCoachingStirrup from '@media/scott/scott-coaching-stirrup-adjustment.webp'
import scottForeheadToHorseBw from '@media/scott/scott-forehead-to-horse-bw.webp'
import scottGroundworkHaltering from '@media/scott/scott-groundwork-haltering-chestnut.webp'
import scottGroundworkHaltering640 from '@media/scott/scott-groundwork-haltering-chestnut-640.webp'
import scottGroundworkHaltering1280 from '@media/scott/scott-groundwork-haltering-chestnut-1280.webp'
import scottGroundworkLiberty from '@media/scott/scott-groundwork-liberty-arena.webp'
import scottMountedChestnutCloseup from '@media/scott/scott-mounted-chestnut-closeup-face.webp'
import scottMountedChestnutSmiling from '@media/scott/scott-mounted-chestnut-smiling-portrait.webp'
import scottPortraitChestnutLeading from '@media/scott/scott-portrait-chestnut-leading-outdoor.webp'
import scottPortraitChestnutSnow from '@media/scott/scott-portrait-chestnut-snow-closeup.webp'
import scottRidingChestnutCanter from '@media/scott/scott-riding-chestnut-canter-arena.webp'
import scottRidingChestnutCanter640 from '@media/scott/scott-riding-chestnut-canter-arena-640.webp'
import scottRidingChestnutTrot from '@media/scott/scott-riding-chestnut-trot-fence.webp'
import scottRidingJackCanter from '@media/scott/scott-riding-jack-canter-arena.webp'
import scottSignatureCursive from '@media/scott/scott-signature-cursive.webp'
import scottStandingChestnutSnow from '@media/scott/scott-standing-chestnut-snow-scene.webp'

// ─── HORSES ───────────────────────────────────────────────────────────────
import horseCraigCameronChestnut from '@media/horses/horse-craig-cameron-chestnut-arena.webp'
import horseRiderBayEnglish from '@media/horses/horse-rider-bay-english-arena.webp'
import horseRiderBeachGallop from '@media/horses/horse-rider-beach-gallop-seagulls.webp'
import horseRiderBeachSunset from '@media/horses/horse-rider-beach-sunset-silhouette.webp'
import horseRiderWhiteWaterside from '@media/horses/horse-rider-white-waterside-english.webp'
import horseStudentGroundwork from '@media/horses/horse-student-groundwork-bay-arena.webp'

// ─── CLINICS ──────────────────────────────────────────────────────────────
import clinicAcceleratorBanner from '@media/clinics/clinic-confidenceaccelerator-community-banner.webp'
import clinicIndoorGroundwork from '@media/clinics/clinic-demo-indoor-groundwork-audience.webp'
import clinicIndoorRiding from '@media/clinics/clinic-demo-indoor-riding-audience.webp'
import clinicGroupKids from '@media/clinics/clinic-group-kids-adults-outdoor.webp'
import clinicGroupRiders from '@media/clinics/clinic-group-riders-arena-lineup.webp'

// ─── APP ──────────────────────────────────────────────────────────────────
import appBadgeAppStoreBlack from '@media/app/app-badge-appstore-black.svg'
import appBadgeAppStoreLight from '@media/app/app-badge-appstore-light.webp'
import appBadgeAppStoreWhite from '@media/app/app-badge-appstore-white.svg'
import appBadgeGooglePlay from '@media/app/app-badge-googleplay-color.webp'
import appCoachScottChat from '@media/app/app-ridersway-askcoachscott-chat.webp'
import appHomescreenMockup from '@media/app/app-ridersway-homescreen-mockup.webp'
import appScreenshotCoachScottChat from '@media/app/app-screenshot-coach-scott-chat.webp'
import appRidersWayHomeCurrent from '@media/app/app-ridersway-home-current.webp'

// ─── PRODUCTS ─────────────────────────────────────────────────────────────
import productConfidentEquestrianBox from '@media/products/product-confident-equestrian-boxmockup.webp'
import productFitnessEquestriansBox from '../assets/products/product-fitness-equestrians-boxmockup-transparent.webp'
import productFitnessPlankLifestyle from '@media/products/product-fitness-equestrians-plank-lifestyle.webp'
import productFitnessSquatLifestyle from '@media/products/product-fitness-equestrians-squat-lifestyle.webp'
import productFoundationBundleBox from '@media/products/product-foundation-bundle-2box-mockup.webp'
import productFoundationGroundworkBox from '../assets/products/product-foundation-groundwork-boxmockup-transparent.webp'
import productFoundationHindquarterBox from '../assets/products/product-foundation-hindquarter-boxmockup-transparent.webp'
import productLibertyFoundationsBox from '../assets/products/product-liberty-foundations-boxmockup-transparent.webp'
import productRidersFoundationBox from '../assets/products/product-riders-foundation-guide-boxmockup-transparent.webp'

// ─── TESTIMONIALS ─────────────────────────────────────────────────────────
import testimonialEmilyJones from '@media/testimonials/testimonial-emily-jones-facebook.webp'
import testimonialLisaCarter from '@media/testimonials/testimonial-lisa-carter-facebook.webp'
import testimonialSarahWilliams from '@media/testimonials/testimonial-sarah-williams-facebook.webp'
import testimonialRoseS from '@media/testimonials/rose-s-testimonial.webp'
import testimonialAliAbusnina1 from '@media/testimonials/ali-abusnina-testimonial-1.webp'
import testimonialAliAbusnina2 from '@media/testimonials/ali-abusnina-testimonial-2.webp'
import testimonialTreiberlisa from '@media/testimonials/treiberlisa-testimonial.webp'

// ─── PEOPLE ───────────────────────────────────────────────────────────────
import peopleNathanGist from '@media/people/people-nathan-gist-headshot.webp'

export const assets = {
  logos: {
    primary: logoPrimary,
    /** Header/footer size. Render at 36 px tall with width={454} height={72}. */
    primaryNav: logoPrimaryNav,
    monogramWhite: logoMonogramWhiteV2,
    monogramWhiteAlt: logoMonogramWhiteV1,
    monogramBlackCropped: logoMonogramBlackCropped,
    monogramBlackSolid: logoMonogramBlackSolid,
    wordmarkBlack: logoWordmarkBlack,
    community: logoCommunityBlack,
    confidentRiders: logoConfidentRidersBlack,
    ridersWay: logoRidersWayNavy,
    ridersWayWordmark: logoRidersWayWordmark,
    ridersWayIcon: logoRidersWayIcon,
    horseTv: logoHorseTvRed,
  },
  scott: {
    headshot: scottHeadshotArena,
    backviewCowboyHat: scottBackviewCowboyHat,
    bondingHorseBw: scottBondingHorseBw,
    coachingStirrup: scottCoachingStirrup,
    foreheadToHorseBw: scottForeheadToHorseBw,
    groundworkHaltering: scottGroundworkHaltering,
    /** srcSet for groundworkHaltering: 640w, 1280w, 2560w (the master). */
    groundworkHalteringSrcSet: `${scottGroundworkHaltering640} 640w, ${scottGroundworkHaltering1280} 1280w, ${scottGroundworkHaltering} 2560w`,
    groundworkLiberty: scottGroundworkLiberty,
    mountedChestnutCloseup: scottMountedChestnutCloseup,
    mountedChestnutSmiling: scottMountedChestnutSmiling,
    portraitChestnutLeading: scottPortraitChestnutLeading,
    portraitChestnutSnow: scottPortraitChestnutSnow,
    ridingChestnutCanter: scottRidingChestnutCanter,
    /** srcSet for ridingChestnutCanter: 640w, 940w (the master). */
    ridingChestnutCanterSrcSet: `${scottRidingChestnutCanter640} 640w, ${scottRidingChestnutCanter} 940w`,
    ridingChestnutTrot: scottRidingChestnutTrot,
    ridingJackCanter: scottRidingJackCanter,
    signature: scottSignatureCursive,
    standingChestnutSnow: scottStandingChestnutSnow,
  },
  horses: {
    beachSunset: horseRiderBeachSunset,
    beachGallop: horseRiderBeachGallop,
    bayEnglish: horseRiderBayEnglish,
    whiteWaterside: horseRiderWhiteWaterside,
    studentGroundwork: horseStudentGroundwork,
    craigCameronChestnut: horseCraigCameronChestnut,
  },
  clinics: {
    acceleratorBanner: clinicAcceleratorBanner,
    indoorGroundwork: clinicIndoorGroundwork,
    indoorRiding: clinicIndoorRiding,
    groupKids: clinicGroupKids,
    groupRiders: clinicGroupRiders,
  },
  app: {
    badgeAppStoreBlack: appBadgeAppStoreBlack,
    badgeAppStoreLight: appBadgeAppStoreLight,
    badgeAppStoreWhite: appBadgeAppStoreWhite,
    badgeGooglePlay: appBadgeGooglePlay,
    coachScottChat: appCoachScottChat,
    screenshotCoachScottChat: appScreenshotCoachScottChat,
    homescreenMockup: appHomescreenMockup,
    homeCurrent: appRidersWayHomeCurrent,
  },
  products: {
    confidentEquestrianBox: productConfidentEquestrianBox,
    fitnessBox: productFitnessEquestriansBox,
    fitnessPlank: productFitnessPlankLifestyle,
    fitnessSquat: productFitnessSquatLifestyle,
    foundationBundle: productFoundationBundleBox,
    foundationGroundwork: productFoundationGroundworkBox,
    foundationHindquarter: productFoundationHindquarterBox,
    libertyFoundations: productLibertyFoundationsBox,
    ridersFoundation: productRidersFoundationBox,
  },
  testimonials: {
    emilyJones: testimonialEmilyJones,
    lisaCarter: testimonialLisaCarter,
    sarahWilliams: testimonialSarahWilliams,
    roseS: testimonialRoseS,
    aliAbusnina1: testimonialAliAbusnina1,
    aliAbusnina2: testimonialAliAbusnina2,
    treiberlisa: testimonialTreiberlisa,
  },
  people: {
    nathanGist: peopleNathanGist,
  },
}
